<template>
<!-- 梦想闹钟 -->
  <div  class="alarm-clock">
      <img class="title" src="https://themes-cdn.xjy.cn/statics/career/images/other/alarm_clock/title1.png" alt="">
      <!--  -->
      <div class="small">写下你2021年最最最重要的3个小目标</div>
      <!--  -->
      <div class="row">
          <p>第1个目标：</p>
          <input type="text" v-model="dream_clock_2020.o1" placeholder="最多输入12个字" />
      </div>
      <div class="row">
          <p>第2个目标：</p>
          <input type="text" v-model="dream_clock_2020.o2" placeholder="最多输入12个字" />
      </div>
      <div class="row on">
          <p>第3个目标：</p>
          <input type="text" v-model="dream_clock_2020.o3" placeholder="最多输入12个字" />
      </div>
      <div class="ft-text">梦想闹钟将于每个星期一早上8点<br/>通过微信向你发出提醒</div>
      <!-- btn -->
      <button class="sub-btn" @click="saveHandle()">提交</button>
      <!-- 自己写祝福语 -->
      <van-popup class="alarm-pop" v-model="alarmShow"  :close-on-click-overlay="dream_clock_2020.num>0?true:false">
          <div class="child">
              <img class="poster" v-if="posterLink" :src="posterLink" alt="">
              <p>长按保存图片，分享到朋友圈<br/>让更多的人来设置自己的梦想闹钟吧~</p>
              <button v-if="this.dream_clock_2020.num>0" @click="updatePoster()" class="btn">修改梦想<span>(仅{{dream_clock_2020.num}}次机会)</span></button>
              <button v-else  class="btn">修改梦想<span>(修改次数已用完)</span></button>
          </div>
      </van-popup>
  </div>
</template>

<script>
import { createPoster,activity_storage_setData,activity_storage_getData,evenAdd } from '@/api/other'
import { deepCopy,isMain } from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bodyShow:false,
            dream_clock_2020:{
                o1:'',
                o2:'',
                o3:'',
                num:4,
                posterLink:''
            },
            alarmShow:false,
            posterLink:''
        }
    },
    computed:{
        text1(){
            return this.dream_clock_2020.o1
        },
        text2(){
            return this.dream_clock_2020.o2
        },
        text3(){
            return this.dream_clock_2020.o3
        }
    },
    watch:{
        // 监听输入的字数长度
        text1(curVal, oldVal){
			if(curVal.length > 12) {
		      this.dream_clock_2020.o1 = curVal.slice(0, 12);
		      this.$toast('最多只能输入12个字符。/(ㄒoㄒ)/~~');
		    }
        },
        // 监听输入的字数长度
        text2(curVal, oldVal){
			if(curVal.length > 12) {
		      this.dream_clock_2020.o2 = curVal.slice(0, 12);
		      this.$toast('最多只能输入12个字符。/(ㄒoㄒ)/~~');
		    }
        },
        // 监听输入的字数长度
        text3(curVal, oldVal){
			if(curVal.length > 12) {
		      this.dream_clock_2020.o3 = curVal.slice(0, 12);
		      this.$toast('最多只能输入12个字符。/(ㄒoㄒ)/~~');
		    }
        }
    },
    methods:{
        // 修改梦想
        updatePoster(){
            this.alarmShow = false;
        },
        // 提交梦想闹钟目标
        saveHandle(){
            let keys = Object.keys(this.dream_clock_2020);
            keys.map(v=>{
                if(!this.dream_clock_2020[v]){
                    this.$toast('请先填写目标！');
                    return
                }
            });
            //调用加载中
            this.$emit('loadingHandle',true,"生成海报中ヾ(◍°∇°◍)ﾉﾞ...");
            let dream_clock_2020 = {
                o1:this.dream_clock_2020.o1,
                o2:this.dream_clock_2020.o2,
                o3:this.dream_clock_2020.o3,
            };
            this.dream_clock_2020.num=this.dream_clock_2020.num-1;
            createPoster({
                qrcode:1,
                poster:'dream_clock_2020',
                params:dream_clock_2020,
                send_image:1
            }).then((res)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (res.error>0) {
                    this.$toast(res.msg || res.detail);
                    return
                }
                this.dream_clock_2020.posterLink = res.image_url;
                 //调用加载中
                this.$emit('loadingHandle',true,"提交数据中ヾ(◍°∇°◍)ﾉﾞ...");
                activity_storage_setData({
                    activity_id:isMain()?13:14, //正式13.测试14
                    data:JSON.stringify(this.dream_clock_2020)
                }).then((data)=>{
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                    if (data.error >0) {
                        this.$toast(data.msg || data.detail);
                        return
                    }
                    
                });
                // 生成海报统计
                let evenObj ={
                    event:'dream_clock_2020'  
                };
                if(this.$route.query.from_user_id){
                    evenObj['from_user_id'] = this.$route.query.from_user_id;
                }
                evenAdd(evenObj).then((data_)=>{});                     
                this.posterLink = res.image_url;
                this.alarmShow = true;
            });
           

        },
        // 初始化获取数据
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"准备梦想闹钟中ヾ(◍°∇°◍)ﾉﾞ...");
            activity_storage_getData({
                activity_id:isMain()?13:14, //正式13.测试14
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (data.error >0) {
                    this.$toast(data.msg || data.detail);
                    return
                }
                if(data.item.data && JSON.parse(data.item.data)){
                    this.dream_clock_2020 = JSON.parse(data.item.data);
                    if(this.dream_clock_2020.num<=0){
                        this.posterLink = this.dream_clock_2020.posterLink;
                        // this.alarmShow = true;
                    }else if(this.dream_clock_2020.posterLink){
                        this.posterLink = this.dream_clock_2020.posterLink;
                        this.alarmShow = true;
                    }
                }
                this.bodyShow = true;
            });
            document.title = '梦想闹钟';
            shareCon("index", this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background: #ffffff;
    }
    .alarm-pop{
        background: transparent;
        .child{
            width: 750px;
            height:1370px;
            background:url('https://themes-cdn.xjy.cn/statics/career/images/other/alarm_clock/alaem-bg.png') center no-repeat;
            background-size: cover;
            padding: 204px 135px 35px;
            box-sizing: border-box;
            text-align: center;
            .poster{
                width: 480px;
                height: 934px;
                margin-bottom: 40px;
            }
            p{
                margin-bottom: 10px;
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #A9AFB3;
                line-height: 28px;
            }
            .btn{
                width: 400px;
                height: 88px;
                background: #E41B7A;
                border-radius: 49px;
                text-align: center;
                font-size: 36px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
                justify-content: center;
                display: flex;
                align-items: center;
                border: none;
                margin: auto;
                span{
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 200;
                    color: #FFFFFF;
                    line-height: 33px;
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
input{
    -webkit-appearance: none;
}
.alarm-clock{
    padding: 68px 30px 60px;
    text-align: center;
    .title{
        width: 100%;
    }
    .small{
        width: 565px;
        height: 72px;
        background: #FFD5E9;
        border-radius: 34px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #E41B7A;
        line-height: 72px;
        margin: 30px auto 80px;
        text-align: center;
    }
    .row{
        margin-bottom: 30px;
        p{
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #7C828A;
            line-height: 42px;
            margin-bottom: 16px;
            text-align: left;
            padding-left:10px ;
        }
        input{
            box-sizing: border-box;
            width: 690px;
            height: 90px;
            background: #FFFFFF;
            border-radius: 50px;
            border: 2px solid #EFEFEF;
            padding: 0 30px;
            font-size: 28px;
        }
    }
    .row.on{
        margin-bottom: 256px;
    }
    .ft-text{
        margin: 0 auto 20px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A9AFB3;
        line-height: 30px;
        text-align: center;
    }
    .sub-btn{
        width: 400px;
        height: 88px;
        background: #E41B7A;
        border-radius: 49px;
        text-align: center;
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
        border: none;
    }
}
</style>